import React, {PureComponent} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {TableRow, TableCell} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import TableCellList from "./TableCellList";
import ListHoc from "../../../../../HocHelpers/ListHoc";

const styles = () => ({
    row: {
        '&:focus': {
            backgroundColor: '#f5f5f5'
        }
    }
});


class TableRowList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isSelected: false
        }
    }


    render() {
        const {
            row,
            isSelected,
            index,
            classes,
            selectable,
            columns,
            pivotData = [],
            pivotColumns = [],
            isCompact,
        } = this.props;
        let newColumns = (pivotData.length > 0  && pivotColumns.length > 0) ? pivotColumns : columns;
        return (
            <TableRow
                hover
                tabIndex={0}
                className={classes.row}
                selected={isSelected}
                style={{
                    height: isCompact && 27,
                    cursor: selectable && "pointer",
                }}>
                {selectable && (
                    <TableCell style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        padding: '0px'
                    }} padding="checkbox">
                        <Checkbox
                            disabled
                            style={{padding: isCompact && 0}}
                            color={"primary"}
                            checked={isSelected}
                        />
                    </TableCell>
                )}
                {(newColumns || []).map((column, colIndex) => {
                    return (
                        <TableCellList
                            key={`cell_${colIndex}_${index}`}
                            value={row[column.name]}
                            column={column}
                            type={row.__props ? row.__props.type : null}
                        />
                    )
                })}
            </TableRow>
        );
    }
}

export default ListHoc(withStyles(styles)(TableRowList));